import { Box, Container, Paper, Typography } from '@mui/material';
import { Section } from 'modules/common/components/Section';
import { useTranslation } from 'modules/i18n';
import { Layout } from 'modules/layout';
import { DarkModeSection } from 'modules/layout/components/DarkModeSection';
import { translation } from './translation';
import { useGeoBlockingStyles } from './useGeoBlockingStyles';
import { LogoWhite } from 'modules/layout/components/Logo/logo-white';
import { Header } from 'modules/layout/screens/DefaultLayout/components/Header';

interface IGeoBlockingProps {
  asPage?: boolean;
}

export function GeoBlocking({
  asPage = false,
}: IGeoBlockingProps): JSX.Element {
  const { keys, t } = useTranslation(translation);
  const { classes } = useGeoBlockingStyles();

  const content = (
    <Section>
      <Container maxWidth={false} className={classes.root}>
        <Paper className={classes.paper}>
          <Box className={classes.logoWrapper}>
            <LogoWhite className={classes.logo} />
          </Box>
          <Typography variant="h4" className={classes.title}>
            {t(keys.title)}
          </Typography>
        </Paper>
      </Container>
    </Section>
  );

  if (asPage) {
    return (
      <Layout
        headerSlot={
          <DarkModeSection>
            <Header hasConnect={false} />
          </DarkModeSection>
        }
      >
        {content}
      </Layout>
    );
  }

  return content;
}
